import styled from 'styled-components'

import { rgba } from '../../DataGrid.styles'
import { COLORS } from '../../DataGrid.theme'

export const Root = styled.div<{ alwaysVisible?: boolean }>`
  flex-shrink: 0;
  position: relative;
  display: ${p => (p.alwaysVisible ? 'flex' : 'none')};
  height: 24px;
  align-items: center;
`
export const IconWrapper = styled.div<{ $isFilterActive?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    color: ${({ $isFilterActive }) => ($isFilterActive ? COLORS.accentMedium : COLORS.neutralDark)};

    &:hover {
      color: ${({ $isFilterActive }) =>
        $isFilterActive ? COLORS.accentMedium : COLORS.neutralExtremelyDark};
    }
  }
`

export const ActiveFilterIndicator = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${COLORS.white};
  height: 12px;
  width: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  position: absolute;
  top: 1px;
  right: 0;
`

export const FilterContainer = styled.div`
  max-width: unset !important;
  color: ${COLORS.black};
  background: ${COLORS.white};
  border: 1px solid ${COLORS.neutralMedium};
  box-sizing: border-box;
  box-shadow: 0 4px 16px ${rgba(COLORS.shadowBlur, 0.4)};
  border-radius: 2px;
  padding: 8px;
  z-index: 1000;
`
